// CEO 2026-10-23 · Version corrigée d'un contrat déjà signé (adresse, état civil…).
import { useState } from "react";
import { toast } from "sonner";
import { Copy, FilePen, Loader2 } from "lucide-react";
import { api } from "../../lib/api";

const fmt = (iso) => (iso ? new Date(iso).toLocaleString("fr-FR", { timeZone: "Europe/Paris", dateStyle: "short", timeStyle: "short" }) : "");

export async function issueContractCorrection(contractId) {
    try {
        await api.post(`/contracts/${contractId}/correction`);
        toast.success("Version corrigée envoyée à la salariée pour signature", {
            description: "Le contrat signé actuel reste valable jusqu'à sa signature, puis il est archivé.",
        });
        return true;
    } catch (err) {
        toast.error(err.response?.data?.detail || "Impossible d'émettre la version corrigée");
        return false;
    }
}

export default function ContractCorrectionPanel({ contract, onChanged }) {
    const [busy, setBusy] = useState(false);
    const corr = contract.correction;
    const pending = corr && ["sent", "opened"].includes(corr.status);

    const issue = async () => {
        if (!window.confirm("Émettre une version corrigée du contrat (avec les informations à jour) et l'envoyer à la salariée pour signature ?")) return;
        setBusy(true);
        if (await issueContractCorrection(contract.id)) onChanged?.();
        setBusy(false);
    };

    const copy = async () => {
        const base = process.env.REACT_APP_BACKEND_URL.replace(/\/api$/, "");
        try {
            await navigator.clipboard.writeText(`${base}/contract/${corr.token}`);
            toast.success("Lien de la version corrigée copié");
        } catch { /* ignore */ }
    };

    return (
        <div className="w-full flex flex-wrap items-center gap-2" data-testid="contract-correction-panel">
            {pending && (
                <span className="inline-flex items-center gap-1.5 rounded-full bg-amber-100 border border-amber-300 text-amber-900 px-3 py-1.5 text-[11px] font-bold" data-testid="contract-correction-pending">
                    Version corrigée envoyée le {fmt(corr.sent_at)} · {corr.status === "opened" ? "ouverte" : "en attente"} de signature
                </span>
            )}
            {corr?.status === "signed" && (
                <span className="inline-flex items-center gap-1.5 rounded-full bg-emerald-100 border border-emerald-300 text-emerald-900 px-3 py-1.5 text-[11px] font-bold" data-testid="contract-correction-signed">
                    Version corrigée signée le {fmt(corr.signed_at)} · ancienne version archivée
                </span>
            )}
            {pending && (
                <button onClick={copy} data-testid="contract-correction-copy-link"
                    className="inline-flex items-center gap-1.5 rounded-full bg-white border border-slate-200 text-slate-700 hover:bg-slate-50 h-9 px-3 text-[11px] font-bold">
                    <Copy className="h-3 w-3" /> Copier le lien
                </button>
            )}
            <button onClick={issue} disabled={busy} data-testid="contract-issue-correction"
                title="Régénère le contrat avec les informations à jour (adresse, état civil…) et l'envoie à la salariée pour une nouvelle signature."
                className="inline-flex items-center gap-1.5 rounded-full bg-white border border-shariti-orange text-shariti-orange hover:bg-shariti-orange-soft h-9 px-3 text-[11px] font-bold disabled:opacity-60">
                {busy ? <Loader2 className="h-3 w-3 animate-spin" /> : <FilePen className="h-3 w-3" />}
                {pending ? "Renvoyer une version corrigée" : "Émettre une version corrigée"}
            </button>
        </div>
    );
}
